module.exports = __webpack_public_path__ + "img/Einhell_logo.f9f6c8a5.jpg";